<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name {{ keyName }}
    .register-value
      b-img.form-image(:src="value" :style="styles" fluid)
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 画像のみコンポーネント
 *
 * - ラベルと画像を表示するのみ
 * - 入力要素コンポーネントと同じレイアウトをサポートする
 */
@Component
export default class FormImage extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  private value!: any;

  /** 項目名 */
  @Prop({ required: true, type: String })
  private keyName!: string;

  /** スタイル(主にサイズ指定) */
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  private styles!: any;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.form-image {
  border: 1px solid $border-darkgray;
}
</style>
